import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=33390d93&"
import script from "./columns.vue?vue&type=script&lang=ts&"
export * from "./columns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports